import React, { useEffect, useState } from "react";
import _ from "lodash";
import moment from "moment";
import WorkflowTableItem from "./WorkflowTableItem";
import { TABLE_NAME } from "../constants";
import { getHistoryWorkflowsForClient } from "../../../services/workflow";

const WorkflowHistoryList = ({ currentCa, clinicPreference }) => {
  const [caList, setCaList] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const firstName = _.get(currentCa, "client.firstName", "");
  const lastName = _.get(currentCa, "client.lastName", "");
  const dateOfBirth = _.get(currentCa, "client.dateOfBirth", "");

  useEffect(() => {
    const run = async () => {
      setIsLoading(true);
      setErrorMessage(null);
      setMessage(null);

      const { data: cas, error } = await getHistoryWorkflowsForClient(firstName, lastName, dateOfBirth);
      setIsLoading(false);

      if (error) {
        setErrorMessage("Something went wrong");
        return;
      }

      if (cas && cas.length <= 1) {
        setMessage("No Data");
        return;
      }

      const historicalCas = _.sortBy(cas, [
        (ca) => {
          const startTime = _.get(ca, "appointment.startDateTime", false);
          return startTime && moment(startTime, "YYYY-MM-DDTHH:mm:ss Z");
        },
      ]).reverse();
      setCaList(historicalCas.filter((ca) => ca.id !== currentCa.id));
    };
    run();
  }, [firstName, lastName, dateOfBirth, currentCa.id]);

  if (isLoading) {
    return <div className="button is-fullwidth is-loading is-white" />;
  }

  if (errorMessage) {
    return <p className="has-text-danger has-text-centered">{errorMessage}</p>;
  }

  if (message) {
    return <p className="has-text-info has-text-centered">{message}</p>;
  }

  return caList.length > 0 ? (
    <table className="table is-hoverable is-fullwidth is-narrow is-size-7 history-table">
      <thead>
        <tr>
          <th>URN</th>
          <th>Category</th>
          <th>Client</th>
          <th>DOB</th>
          <th>Creation DT</th>
          <th>Referrer</th>
          <th>Case Manager</th>
          <th>Speciality</th>
          <th>Clinic</th>
          <th>APT Date</th>
          <th>Bookings</th>
          <th>Results</th>
          <th>Notes</th>
        </tr>
      </thead>
      <tbody>
        {caList.map((ca) => (
          <WorkflowTableItem key={ca.id} ca={ca} clinicPreference={clinicPreference} tableName={TABLE_NAME.history} />
        ))}
      </tbody>
    </table>
  ) : (
    <></>
  );
};

export default WorkflowHistoryList;
